<template>
  <div>
    <el-dialog
      @close="handleClose"
      :visible="visible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :center="true"
      custom-class="validate-phone-dialog"
      width="530px"
      title="手机验证"
    >
      <div class="box">
        <el-form class="form" ref="form" :model="form" :rules="rules">
          <el-form-item prop="phoneNum">
            <el-input
              size="medium"
              v-model="form.phoneNum"
              :placeholder="$t('account.phoneNumPlaceholder')"
            >
            </el-input>
          </el-form-item>

          <el-form-item prop="code">
            <el-input
              size="medium"
              v-model="form.code"
              :placeholder="$t('account.codePlaceholder')"
              @keyup.native.enter="handleSubmit"
              :style="{ width: 'calc(100% - 124px)', marginRight: '12px' }"
            >
            </el-input>
            <el-button
              size="medium"
              type="primary"
              class="send-code-btn"
              :disabled="hasSend"
              @click="handleSendCode"
            >
              {{ sendCodeBtnText }}
            </el-button>
          </el-form-item>
        </el-form>

        <el-button
          type="primary"
          size="medium"
          class="validate-btn"
          :loading="loading"
          @click="handleSubmit"
        >
          验证
        </el-button>

        <p class="err-msg" v-if="errMsg">
          {{ errMsg }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getErrorCode, getDefaultErrorText } from '@/views/login/mixin'

export default {
  name: 'ValidatePhoneDialog',
  props: {
    visible: Boolean
  },

  data() {
    return {
      errMsg: '',
      loading: false,
      rules: {
        phoneNum: [
          {
            required: true,
            message: this.$t('account.phoneNumPlaceholder'),
            trigger: 'blur',
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t('account.phoneNumError'),
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: this.$t('account.codePlaceholder'),
            trigger: 'blur',
          },
          {
            pattern: /^\d{6}$/,
            message: this.$t('account.codeError'),
            trigger: 'blur',
          },
        ],
      },
      form: {
        phoneNum: '',
        code: '',
      },

      hasSend: false,
      sendCnt: 0,
      count: 60,
    }
  },

  computed: {
    sendCodeBtnText() {
      return this.hasSend ? `${this.count}s` : this.sendCnt > 0 ? this.$t('account.reSend') : this.$t('account.sendCode')
    },
  },

  methods: {
    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('update:visible', false)
    },

    // 验证表单字段promise化
    validateField(field) {
      return new Promise((resolve, reject) => {
        this.$refs.form.validateField(field, (err) => {
          if (err) {
            reject(err)
          } else {
            resolve()
          }
        })
      })
    },

    async handleSendCode() {
      try {
        await this.validateField('phoneNum')
      } catch (error) {
        return
      }

      // 发送验证码
      try {
        const { code } = await this.$store.dispatch('SendCode', this.form.phoneNum)
        if (code === 200) {
          this.hasSend = true
          this.sendCnt++
          this.count = 60
          const timer = setInterval(() => {
            this.count--
            if (this.count <= 0) {
              clearInterval(timer)
              this.hasSend = false
            }
          }, 1000)
        } else {
          this.errMsg = getErrorCode()[code]
        }
      } catch (error) {
        console.error(error)
        this.errMsg = getDefaultErrorText()
      }
    },

    handleBindPhone() {
      return this.$store.dispatch('BindPhone', {
        phoneNum: this.form.phoneNum,
        code: this.form.code
      })
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }
      this.errMsg = ''
      this.loading = true

      try {
        const { code } = await this.handleBindPhone()
        if (code === 200) {
          await this.$store.dispatch('GetInfo')
          this.handleClose()
          this.$emit('bind-success')
        } else {
          this.errMsg = getErrorCode()[code] ?? getDefaultErrorText()
        }
      } catch (e) {
        console.error(e)
        this.errMsg = getDefaultErrorText()
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.validate-phone-dialog {
  .el-form-item__error {
    margin-left: 60px;
  }

  .box {
    width: 350px;
    margin: 20px auto 10px;

    .el-form-item__error {
      margin-left: 0px;
    }
  }

  .err-msg {
    margin-top: 6px;
    font-size: 12px;
    color: #f56c6c;
    text-align: center;
  }

  .send-code-btn {
    min-width: 112px;
  }

  .validate-btn {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
</style>
